import React from "react";

const FaiTabContext = React.createContext({
  tabValue: "",
  setTabValue: () => {}
});

export default FaiTabContext;